import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import './FormError.scss';

interface IFormError {
  errorText?: string;
}

const FormError: React.FC<IFormError> = ({ errorText }) => {
  return (
    <>
      <FaExclamationTriangle className='form-error__triangle' />
      <div className='form-error'>
        <span className='form-error__text'>{errorText}</span>
      </div>
    </>
  );
};

export default FormError;
